export const EXTENSION_NAME = "one-siam"
export const SEE_AND_DO_POST_TYPE = "post-category-onesiam-0-see-and-do"
export const NEXTOPIA_POST_TYPE = "post-category-onesiam-0-nextopia"
export const NEXTOPIA_CATEGORY_TYPE = "local-category-onesiam-0-nextopia"
